import {
    createPageMetricsForResponse,
    PageType,
} from '@jet-app/music-classical/metrics/page';
import { ObjectGraph } from '@jet/environment/dependencies';

import type {
    ClassicalAPIResponse,
    ClassicalAPIResponseHeader,
    ClassicalGrid,
    ClassicalListViewPage,
} from '@jet-app/music-classical/api/types';
import type {
    SeeAllPage,
    SeeAllPageHeader,
} from '@jet-app/music-classical/models/pages/see-all';
import { transformToGridSection } from '@jet-app/music-classical/utilities/transforms/grid';
import { makeSeeAllPaginationIntent } from './paginate/SeeAllPaginationIntent';

export function renderSeeAllPage(
    apiResponse: ClassicalAPIResponse,
    objectGraph: ObjectGraph,
    canonicalURL?: string,
    isCharts?: boolean,
): SeeAllPage {
    const responseBody = apiResponse?.body as ClassicalListViewPage;
    const responseHeader = (responseBody?.header ||
        {}) as unknown as ClassicalAPIResponseHeader;

    const nextIntentURL = responseBody?.firstPage?.next;

    // Retyping this otherwise TS won't allow extending SeeAllPage from Page
    const header = { ...responseHeader } as unknown as SeeAllPageHeader;
    const components =
        responseBody?.firstPage || responseBody?.sections?.[0]?.components?.[0];
    const sections =
        components.type === 'empty'
            ? []
            : [
                  transformToGridSection(
                      components,
                      getItemKindByType(components?.items?.[0]?.type),
                      undefined,
                      objectGraph,
                      isCharts,
                  ),
              ];

    return {
        pageKind: 'componentScreen',
        kind: 'SeeAllPage',
        header,
        sections,
        canonicalURL,
        nextIntent: nextIntentURL
            ? makeSeeAllPaginationIntent({
                  url: nextIntentURL,
                  id: sections?.[0]?.id,
              })
            : null,
        pageMetrics: createPageMetricsForResponse(
            apiResponse,
            PageType.seeAllPage,
        ),
    };
}

export function getItemKindByType(itemType: string) {
    return ['artist', 'work'].includes(itemType)
        ? 'ellipseLockup'
        : 'squareLockup';
}
